import React, { useCallback, useRef } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import FacebookCarouselItem from './FacebookCarouselItem'

import useElementWidth from '../../../../../hooks/useElementWidth'

import { setAdCarouselSelectedIndex } from '../../../../../modules/actions/ads'
import { adCarouselSelectedIndexesSelector } from '../../../../../modules/selectors/ads'

import { AD_PREVIEW_CAROUSEL_INDEX_KEY, CAROUSEL_ITEMS } from '../../../../../forms/Facebook/AdForms/fields'

import useStyles from './styles'

function FacebookCarousel({ viewAdOnFacebook, formikValues, elementInProgress, isSoundMuted }) {
  const classes = useStyles()
  const dispatch = useDispatch()

  const carouselContainerRef = useRef(null)

  const carouselContainerWidth = useElementWidth(carouselContainerRef)

  const selectedCarouselIndexes = useSelector(adCarouselSelectedIndexesSelector)

  const carouselItems = formikValues[CAROUSEL_ITEMS]
  const adPreviewCarouselIndexKey = formikValues[AD_PREVIEW_CAROUSEL_INDEX_KEY]
  const lastItemIndex = carouselItems.length - 1

  const isCarouselInProgress = elementInProgress === CAROUSEL_ITEMS

  const selectedCarouselItemIndex = selectedCarouselIndexes[adPreviewCarouselIndexKey] || 0

  const handleCarouselItemClick = useCallback(
    ({ index }) => {
      dispatch(setAdCarouselSelectedIndex(adPreviewCarouselIndexKey, index))
    },
    [dispatch, adPreviewCarouselIndexKey]
  )

  return (
    <div className={classes.carousel} ref={carouselContainerRef}>
      {!!carouselItems.length &&
        carouselItems.map((item, index) => (
          <FacebookCarouselItem
            viewAdOnFacebook={viewAdOnFacebook}
            key={index}
            formikValues={formikValues}
            selectedCarouselItemIndex={selectedCarouselItemIndex}
            lastItemIndex={lastItemIndex}
            item={item}
            isActive={selectedCarouselItemIndex === index && isCarouselInProgress}
            elementInProgress={elementInProgress}
            handleItemClick={handleCarouselItemClick}
            index={index}
            isSoundMuted={isSoundMuted}
            carouselContainerWidth={carouselContainerWidth}
          />
        ))}
      {
        // carousel should have at least 2 items, when no 2nd item - show FacebookCarouselItem as placeholder
        carouselItems.length === 1 && <FacebookCarouselItem />
      }
    </div>
  )
}

FacebookCarousel.propTypes = {
  viewAdOnFacebook: PropTypes.string,
  formikValues: PropTypes.object,
  elementInProgress: PropTypes.string,
  isSoundMuted: PropTypes.bool
}

export default FacebookCarousel
